export class CONSTANT {

    public static GROUP_MAYBANK2UPAY               = 1; 
    public static GROUP_CREDITCARD                 = 2;

    public static SERVICE_MAYBANK2UPAY             = 2;
    public static SERVICE_CREDITCARD_ECOMMERCE     = 9;
    public static SERVICE_CREDITCARD_POSMPOS       = 10;


    public static COUNTRIES = [
        "Malaysia",
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas, The",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burma",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cabo Verde",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Congo, Democratic Republic of the",
        "Congo, Republic of the",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Curacao",
        "Cyprus",
        "Czechia",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia, The",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Holy See",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",//
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestinian Territories",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",//
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ]

    public static REJECT_COUNTRY = [
       "Iran",
       "North Korea",
       "Cuba",
       "Ukraine",
       "Syria"
    ]

    public static BUSINESS_TYPES = {
       1:"Public Listed (Berhad)",
       2:"Private Limited (Sendirian Berhad)",
       3:"Sole Proprietary",
       4:"Partnership",
       5:"NGOs/Association",
       6:"Government",
       7:"Joint Management Body",
       8:"Professional Body: Law Firm",
       9:"Professional Body: Clinic",
       10:"Other Professional Body"
       
    }
    public static BUSINESS_TYPES_ARRAY = [
       "Public Listed (Berhad)",
       "Private Limited (Sendirian Berhad)",
       "Sole Proprietary",
       "Partnership",
       "NGOs/Association",
       "Government",
       "Joint Management Body",
       "Professional Body: Law Firm",
       "Professional Body: Clinic",
       "Other Professional Body"
       
    ]
      
    // public static BUSINESS_POSITION = {
    //     1 : [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     2 : [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     3 : [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     4 : [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     5: [
    //         "Chairman/ President",
    //         "Vice Chairman/ Vice President",
    //         "Secretary",
    //         "Treasurer"

    //     ],
    //     6 : [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     7 : [
    //         "Chairman/ President",
    //         "Vice Chairman/ Vice President",
    //         "Secretary",
    //         "Treasurer"
    //     ],
    //     8 : [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     9: [
    //        "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"
    //     ],
    //     10: [
    //         "Director",
    //         "Shareholder",
    //         "Partner",
    //         "Owner"

    //     ]      

    // }
    // public static BUSINESS_DOCUMENTS = {
    //     1: [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Changes in the Register of Directors, Managers & Secretaries",
    //             "required":false,
    //             "type": "changes_in_register"
    //         },
    //         {
    //             "title":"Change of Company Name",
    //             "required":false,
    //             "type": "change_in_company_name"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         }
    //     ],
    //     2 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Changes in the Register of Directors, Managers & Secretaries",
    //             "required":false,
    //             "type": "changes_in_register"
    //         },
    //         {
    //             "title":"Change of Company Name",
    //             "required":false,
    //             "type": "change_in_company_name"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         }
    //     ],
    //     3 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         },
    //         {
    //             "title":"Extract of Registration of Business Name (if any - applicable to Sarawak Only)",
    //             "required":false,
    //             "type": "extract_of_registration_business_name"
    //         },
    //         {
    //             "title":"Form B (if any - applicable to Sabah Only)",
    //             "required":false,
    //             "type": "form_B"
    //         }
    //     ],
    //     4 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         },
    //         {
    //             "title":"Extract of Registration of Business Name (if any - applicable to Sarawak Only)",
    //             "required":false,
    //             "type": "extract_of_registration_business_name"
    //         },
    //         {
    //             "title":"Form B (if any - applicable to Sabah Only)",
    //             "required":false,
    //             "type": "form_B"
    //         }
    //     ],
    //     5 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         },
    //         {
    //             "title":"Minutes Of Meeting",
    //             "required":true,
    //             "type": "minutes_of_meeting"
    //         }

    //     ],
    //     6 : [
    //         {
    //             "title":"Circular of Ministry of Finance",
    //             "required":true,
    //             "type": "circular_of_ministry_of_finance"
    //         }
    //     ],
    //     7 : [
    //         {
    //             "title":"Minutes Of Meeting with list of Committees",
    //             "required":true,
    //             "type": "minutes_of_meeting"
    //         },
    //         {
    //             "title":"Perakuan Penubuhan Badan Pengurusan Bersama",
    //             "required":true,
    //             "type": "perakuan_penubuhan_badan_pengurusan_bersama"
    //         }
    //     ],
    //     8 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Changes in the Register of Directors, Managers & Secretaries",
    //             "required":false,
    //             "type": "changes_in_register"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         },
    //         {
    //             "title":"Valid Practising License",
    //             "required":true,
    //             "type": "valid_practising_license"
    //         }
    //     ],
    //     9 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Changes in the Register of Directors, Managers & Secretaries",
    //             "required":false,
    //             "type": "changes_in_register"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         },
    //         {
    //             "title":"Form B/C/F (Akta Kemudahan dan Perkhidmatan Jagaan Kesihatan Swasta)",
    //             "required":true,
    //             "type": "form_b_c_f"
    //         },
    //         {
    //             "title":"Perakuan Amalan Tahunan",
    //             "required":true,
    //             "type": "perakuan_amalan_tahunan"
    //         }
    //     ],
    //     10 : [
    //         {
    //             "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
    //             "required":true,
    //             "type": "company_registration_form"
    //         },
    //         {
    //             "title":"Changes in the Register of Directors, Managers & Secretaries",
    //             "required":false,
    //             "type": "changes_in_register"
    //         },
    //         {
    //             "title":"Business License",
    //             "required":true,
    //             "type": "business_license"
    //         },
    //         {
    //             "title":"Valid Practising License",
    //             "required":true,
    //             "type": "valid_practising_license"
    //         }
    //     ]      


        
    // }

    public static BUSINESS_DOCUMENTS = {
        "Public Listed (Berhad)" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Changes in the Register of Directors, Managers & Secretaries",
                "required":false,
                "type": "changes_in_register"
            },
            {
                "title":"Change of Company Name",
                "required":false,
                "type": "change_in_company_name"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            }
        ],
        "Private Limited (Sendirian Berhad)" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Changes in the Register of Directors, Managers & Secretaries",
                "required":false,
                "type": "changes_in_register"
            },
            {
                "title":"Change of Company Name",
                "required":false,
                "type": "change_in_company_name"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            }
        ],
        "Sole Proprietary" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            },
            {
                "title":"Extract of Registration of Business Name (if any - applicable to Sarawak Only)",
                "required":false,
                "type": "extract_of_registration_business_name"
            },
            {
                "title":"Form B (if any - applicable to Sabah Only)",
                "required":false,
                "type": "form_B"
            }
        ],
        "Partnership" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            },
            {
                "title":"Extract of Registration of Business Name (if any - applicable to Sarawak Only)",
                "required":false,
                "type": "extract_of_registration_business_name"
            },
            {
                "title":"Form B (if any - applicable to Sabah Only)",
                "required":false,
                "type": "form_B"
            }
        ],
        "Government" : [
            {
                "title":"Circular of Ministry of Finance",
                "required":true,
                "type": "circular_of_ministry_of_finance"
            }
        ],
        "Joint Management Body" : [
            {
                "title":"Minutes Of Meeting with list of Committees",
                "required":true,
                "type": "minutes_of_meeting"
            },
            {
                "title":"Perakuan Penubuhan Badan Pengurusan Bersama",
                "required":true,
                "type": "perakuan_penubuhan_badan_pengurusan_bersama"
            }
        ],
        "NGOs/Association": [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            },
            {
                "title":"Minutes Of Meeting",
                "required":true,
                "type": "minutes_of_meeting"
            }

        ],
        "Professional Body: Law Firm" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Changes in the Register of Directors, Managers & Secretaries",
                "required":false,
                "type": "changes_in_register"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            },
            {
                "title":"Valid Practising License",
                "required":true,
                "type": "valid_practising_license"
            }
        ],
        "Professional Body: Clinic" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Changes in the Register of Directors, Managers & Secretaries",
                "required":false,
                "type": "changes_in_register"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            },
            {
                "title":"Form B/C/F (Akta Kemudahan dan Perkhidmatan Jagaan Kesihatan Swasta)",
                "required":true,
                "type": "form_b_c_f"
            },
            {
                "title":"Perakuan Amalan Tahunan",
                "required":true,
                "type": "perakuan_amalan_tahunan"
            }
        ]
        ,
        "Other Professional Body" : [
            {
                "title":"Company Registration Form (Form 24, 49, Sectiom 14, 17, M&A, Form D, Form E, etc)",
                "required":true,
                "type": "company_registration_form"
            },
            {
                "title":"Changes in the Register of Directors, Managers & Secretaries",
                "required":false,
                "type": "changes_in_register"
            },
            {
                "title":"Business License",
                "required":true,
                "type": "business_license"
            },
            {
                "title":"Valid Practising License",
                "required":true,
                "type": "valid_practising_license"
            }
        ]      


        
    }

    public static BUSINESS_POSITION = {
         "Public Listed (Berhad)" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ],
        "Private Limited (Sendirian Berhad)" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ],
        "Sole Proprietary" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ],
        "Partnership" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ],
        "Government" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ],
        "Joint Management Body" : [
            "Chairman/ President",
            "Vice Chairman/ Vice President",
            "Secretary",
            "Treasurer"
        ],
        "NGOs/Association": [
            "Chairman/ President",
            "Vice Chairman/ Vice President",
            "Secretary",
            "Treasurer"

        ],
        "Professional Body: Law Firm" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ],
        "Professional Body: Clinic" : [
           "Director",
            "Shareholder",
            "Partner",
            "Owner"
        ]
        ,
        "Other Professional Body" : [
            "Director",
            "Shareholder",
            "Partner",
            "Owner"

        ]      

    }


    public static SERVICE_DESC = {
        "Online Banking":{
            "desc":"Allows your customers to pay online from their Maybank Current/Savings Account"
        },
        "Cards Payment Gateway":{
            "desc":"Allows your customers to pay online with their Cards"
        },
        "POS Terminal":{
            "desc":"Allows your customers to pay by Cards over the counter."
        },
        "mPOS":{
            "desc":"A portable POS terminal using your mobile device or tablet."
        },
        "FPX":{
            "desc":"An online payment gateway system to facilitate payment between participating financial institutions"
        },
        "JomPAY":{
            "desc":"A Bill Payment service that allows your customers to easily pay your bills and invoices using bank accounts or credit cards at 42 banks’ Internet and Mobile Banking"
        },
        "AutoDebit":{
            "desc":"A bill payment facility that automatically settles your customers' bills by deducting from their Maybank savings/current account on a fixed schedule "
        },
        "Maybank2u Biller":{
            "desc":"An online bill payment facility that lets you settle bills by debiting your Maybank savings/current account or credit card"
        },
        "POS Terminal / mPOS":{
            "desc":"Allows your customers to pay by normal card terminal or portable POS terminal using your mobile device or tablet."
        },
        "QRPayBiz":{
            'desc':'Allows your customer to pay using a unique two-dimensional quick-response (QR) code .'
        }


    }

    public static SERVICE = 
   {
     MAYBANK2U_BILLER:1,
     ONLINE_BANKING: 2,
     JOMPAY: 3,
     AUTODEBIT: 4,
     ATM: 5,
     CDM: 6,
     FPX: 7,
     MAYBANK2U_PAY_DPE_MOBILE_SDK: 8,
     CARDS_PAYMENT_GATEWAY: 9,
     POS_TERMINAL_MPOS: 10,
     QRPAY: 11
   };



   public static STATUS = 
   {
     OPEN:1,
     REJECTED:8,
     PENDING_ACCOUNT_CREATION        :9,
     ONLINE_BANKING:{
       REVIEWED                        :2,
       APPROVED                        :3,
       SUBMIT_TO_PRODUCT_MANAGEMENT    :4,
       SUBMIT_TO_PRODUCTION            :5,
       COMPLETE_PAYEE_CREATION         :6,
       APPLICATION_PROCESS_COMPLETED   :7,
       REAPPLY                         :10,
       DATAPOWER_CONFIGURED            :11,
       SUBMIT_TO_DATAPOWER             :12,
       PENDING_TECH_SPEC               :13,
       UAT_DATAPOWER_CONFIGURED        :14
     },
     CARDS: {
      PENDING_WEB_CHECKLIST_APPROVAL   : 15,
      WEB_CHECKLIST_MIN_CHECK_PASSED   : 16,
      PENDING_MERCHANT_BIZ_REVIEW      : 17,
      APPROVED                         : 18,
      PENDING_MID_SETUP                : 19,
      PENDING_UAT_SETUP                : 20,
      READY_FOR_UAT                    : 21,
      UAT_COMPLETED                    : 22,
      UAT_VERIFIED                     : 23,
      GO_LIVE                          : 24
     },
     CLOSED: 24,
     JOMPAY: {
        APPROVED                            : 3,
        REJECTED                            : 8,
        COMPLETE_PAYEE_CREATION             : 6,
        REVIEW                              : 26,
        RECOMMEND_TO_REJECT                 : 27,
        RETURN_APPLICATION_INCOMPLETE       : 28,
        RECOMMEND_TO_APPROVED               : 29,
        REVIEWER                            : 30,
        DOCUMENT_GENERATED                  : 31,
        CUSTOMER_UPLOADED_DOCUMENTS         : 32,
        DOCUMENT_REJECTED                   : 33,
        TRIGGER_BILLER_CODE                 : 34,
        RECEIVED_BILLER_CODE                : 35,
        RECEIVED_BILLER_CODE_FAIL           : 36,
        BACKEND_SETUP                       : 37,
        BACKEND_SETUP_FAILED                : 38,
        BACKEND_SETUP_COMPLETED             : 39
     }

   };

   public static SUBTAG = 
   {
     ACCOUNT_CREATED:1,
     WC_REQUIRES_MERCHANT_REVIEW:2,
     WEB_CHECKLIST_COMPLETE:3,
     LO_ACCEPTED: 4,
     LO_REJECTED: 5,
     LO_UPLOADED: 6,
     MSOS_CODE_RECEIVED: 7,
     TECH_SPEC_SUBMITTED                   : 8,
        WC_REQUIRES_ECOMMERCE_REVIEW          : 9,
     M2UPAY_UAT_COMPLETED                   :10
   };

   public static REGION=
   {
        1:"PKP",
        2:"PKT",
        3:"MNS",
        4:"SELANGOR",
        5:"FT",
        6:"JOHOR",
        7:"SARAWAK",
        8:"SABAH",
        9:"PERAK",
        10:"ALL"
    };

    public static REGION_STATES=
    {
        1                                 :[3,10,9],
        2                                 :[7,4,11],
        3                                 :[5,6],
        4                            :[14,15],
        5                                  :[1],
        6                               :[2],
        7                             :[13],
        8                               :[12,16],
        9                               :[8],
        10                              :[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]
    };
    public static STATES=
    {
        1:"WILAYAH PERSEKUTUAN KUALA LUMPUR",
        2:"JOHOR",
        3:"KEDAH",
        4:"KELANTAN",
        5:"MELAKA",
        6:"NEGERI SEMBILAN",
        7:"PAHANG",
        8:"PERAK",
        9:"PERLIS",
        10:"PULAU PINANG",
        11:"TERENGGANU",
        12:"SABAH",
        13:"SARAWAK",
        14:"SELANGOR",
        15:"WILAYAH PERSEKUTUAN PUTRAJAYA",
        16:"WILAYAH PERSEKUTUAN LABUAN"
    }

    public static STATES_ARRAY=[
        "WILAYAH PERSEKUTUAN KUALA LUMPUR",
        "JOHOR",
        "KEDAH",
        "KELANTAN",
        "MELAKA",
        "NEGERI SEMBILAN",
        "PAHANG",
        "PERAK",
        "PERLIS",
        "PULAU PINANG",
        "TERENGGANU",
        "SABAH",
        "SARAWAK",
        "SELANGOR",
        "WILAYAH PERSEKUTUAN PUTRAJAYA",
        "WILAYAH PERSEKUTUAN LABUAN"
   ]



        
    
}
